module.exports = __webpack_public_path__ + "static/Glober_xBold-2a685ded42f714c71bb64c4a98e2d5cf.eot";